/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';

export interface ScFinalFormProps<
    FormValues = Record<string, any>,
    InitialFormValues = Partial<FormValues>,
> extends Omit<
    FormProps<FormValues, InitialFormValues>,
    'render' | 'component' | 'children'
> {
    render: (
        props: FormRenderProps<FormValues, InitialFormValues>,
    ) => React.ReactNode;
}

function ScFinalForm<
    FormValues = Record<string, any>,
    InitialFormValues = Partial<FormValues>,
>({
    onSubmit,
    initialValues,
    render,
    ...restProps
}: ScFinalFormProps<FormValues, InitialFormValues>) {
    return (
        <Form<FormValues, InitialFormValues>
            {...restProps}
            onSubmit={onSubmit}
            initialValues={initialValues}
            render={render}
        />
    );
}

export default ScFinalForm;
